module.exports = { "default": require("core-js/library/fn/object/create"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** ../~/rc-table/~/babel-runtime/core-js/object/create.js
 ** module id = 1919
 ** module chunks = 3
 **/